import React from 'react'
import { ASC } from '../state/reducer'
import PropTypes from 'prop-types'


const SortIcon = ({ orderBy, columnName }) => {
    const sortOrder = orderBy[columnName]

    if (!sortOrder) {
        return (<i className="fa fa-sort sortIcon"/>)
    }

    if (sortOrder === ASC) {
        return (<i className="fa fa-sort-amount-asc sortIcon"/>)
    }

    return <i className="fa fa-sort-amount-desc sortIcon"/>
}

SortIcon.propTypes = {
    orderBy: PropTypes.object.isRequired,
    columnName: PropTypes.string.isRequired,
}

export default SortIcon



// WEBPACK FOOTER //
// ./src/modules/table/component/SortIcon.js